import React, { Component, Fragment } from "react";
import {
  InputGroup, InputGroupAddon, Input,
  Row, Col, Button, Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BlockUi from 'react-block-ui';
import Pagination from "react-js-pagination";
import moment from 'moment';
import Select from 'react-select';
import { confirmAlert } from 'react-confirm-alert';
const isNumber = require('is-number');

import { ButtonExt } from "../controls/ButtonExt"
import { CheckboxExt } from "../controls/CheckboxExt"
import * as khachhangConstant from './constants'
import * as khachhangAction from './actions'
import { storedb } from '../client/storedb'
import ExcelReader from "../controls/_ExcelReader";
import SortRecordText from "../controls/_SortRecordText"
import { BtnPermissions } from '../../lib/BtnPermissions';
import * as common from '../../lib/common'
import { customSelectStyles, HasPermission } from '../../lib/common';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import ViewTraThuong from './_ViewTraThuong';

class KhachHang extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      stores_id: dbContext.getStoreId(),
      item: {},
      list: [],
      TenQuanLy: '',
      keyword: '',
      per_page: 20,
      page: 1,
      total_record: 0,
      modalPoint: false,
      modal: false,
      dataErr: [],
      TrangThaiId: 1,
      listDvhc: [],
      selectedOptionTinhThanh: null,
      TinhThanhId: 0,
      khachHangIds: [],
      selectedAll: false,
      NhomKhachHangId: 0,
      modalUpdateTraThuong: false,
      sortItems: [
        { value: 'Id', text: 'Mới nhất' },
        { value: 'Ma', text: 'Theo mã' },
        { value: 'Ten', text: 'Theo tên' },
      ],
      sortValue: 'Id',
      phanLoaiKh: [
        { value: -1, text: 'Tất cả' },
        { value: 1, text: 'Đã liên thông 247' },
        { value: 0, text: 'Chưa liên thông 247' },
      ],
      phanLoaiValue: -1
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      case "tenQuanLy":
        this.setState({ TenQuanLy: e.target.value });
        break;
      default:
        break;
    }
  }
  handleKhachHangClick(option) {
    let { khachHangIds } = this.state;
    var index = khachHangIds.indexOf(option.KhachHangId);
    if (index !== -1) {
      khachHangIds.splice(index, 1);
    }
    else {
      khachHangIds.push(
        option.KhachHangId
      );
    }
    this.setState({ khachHangIds });
  }
  checkedKhachHangAll = () => {
    let { list, khachHangIds, selectedAll } = this.state;
    selectedAll = !selectedAll;
    khachHangIds = [];
    if (selectedAll) {
      if (list && list.length > 0) {
        list.map((res, idx) => (
          khachHangIds.push(res.KhachHangId)
        ))
      }
    } else {
      khachHangIds = []
    }
    this.setState({ khachHangIds, selectedAll }, () => {
      $('.cb-item').prop('checked', selectedAll);
    });
  }
  handleSelectChange = (name, selectedOption) => {
    let { item } = this.state;
    if (selectedOption.name) {
      switch (selectedOption.name) {
        case "TinhThanh":
          this.setState({ selectedOptionTinhThanh: name, TinhThanhId: name.value })
          break;
      }
    } else {
      switch (name) {
        case "TrangThai":
          this.setState({ TrangThaiId: selectedOption.target.value })
          break;
        case "NhomKhachHang":
          this.setState({ NhomKhachHangId: selectedOption.target.value })
          break;
        case "PhanLoaiKhachHang":
          this.setState({ phanLoaiValue: selectedOption.target.value })
          break;
        default:
          break;
      }
    }

    this.setState({ item })
  }
  convertToMoment = (date) => {
    if (typeof date == 'string') {
      return moment(date);
    }
    return date;
  }
  fetchList = (page) => {
    $('.cb-item').prop('checked', false);
    $('.cb-item-all').prop('checked', false);
    this.setState({ selectedAll: false, khachHangIds: [] });
    const { khachhangListRequest } = this.props
    var requestData = this.getParamsForRequest(false, page)
    return khachhangListRequest(requestData);
  }
  featchDvhc = () => {
    const { khachhangDvhcListRequest } = this.props;
    let requestData = {
      stores_id: this.state.stores_id
    };
    return khachhangDvhcListRequest(requestData);
  }
  featchNhomKhachHang = () => {
    const { khachhangNhomListRequest } = this.props;
    return khachhangNhomListRequest();
  }
  getParamsForRequest = (isExport, page) => {
    var requestData = {
      store_id: this.state.stores_id,
      keyword: this.state.keyword || '',
      quan_ly: this.state.TenQuanLy || '',
      tungay: '',
      denngay: '',
      tinh_id: this.state.TinhThanhId || 0,
      trang_thai: this.state.TrangThaiId || '',
      nhom_id: this.state.NhomKhachHangId || 0,
      sort: this.state.sortValue || 'Id',
      phanLoai: this.state.phanLoaiValue || -1
    }
    if (!isExport) {
      requestData["page"] = page || this.state.page
      requestData["per_page"] = this.state.per_page
    }
    return requestData
  }
  exportXls = () => {
    const { khachhangExportXlsRequest } = this.props
    var requestData = this.getParamsForRequest(true, null)
    return khachhangExportXlsRequest(requestData, (listExp) => {
      var dataFile = new Blob([listExp], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExport';
      var fileName = "ds_khach_hang.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExport";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
      }
    });
  }
  search = () => {
    if (this.props.khachhang.listRequesting) {
      return false;
    }
    return this.setState({ page: 1 }, () => {
      this.fetchList(1);
    });
  }
  keyPress = (e) => {
    if (e.keyCode == 13) {
      this.search()
    }
  }
  refresh = () => {
    this.setState({
      stores_id: this.state.stores_id,
      keyword: '',
      page: this.state.page,
      per_page: this.state.per_page
    }, () => {
      if (this.props.khachhang.listRequesting) {
        return false;
      }
      return this.fetchList()
    })
  }
  EditkhachhangItem = (item) => {
    this.props.history.push('/khachhang-edit?kid=' + (item.KhachHangId || ""));
  }
  EditHopDongItem = (item) => {
    this.props.history.push('/hopdong?kid=' + (item.KhachHangId || ""));
  }
  viewkhachhangItem = (e, item) => {
    e.preventDefault()
    this.props.history.push('/sale-report?kh=' + item.KhachHangId + "&ql=" + item.IdQuanLy);
  };
  EditkhachhangUser = () => {
    this.props.history.push('/khachhang-user');
  }
  componentDidMount() {
    this.featchDvhc();
    this.featchNhomKhachHang();
    this.fetchList();
  }
  toggle = () => {
    this.resetErrorAndMsg()
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }
  pointToggle = () => {
    this.resetErrorAndMsg()
    this.setState(prevState => ({
      modalPoint: !prevState.modalPoint,
    }));
  }
  DownLoadFile = (srcFile) => {
    const link = document.createElement('a');
    link.href = srcFile
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  UploadPointExcel = (data) => {
    this.resetErrorAndMsg()
    let arrData = [];
    if (data.length > 1) {
      for (var i = 1; i < data.length; i++) {
        if (!data[i][0]) {
          continue
        }
        let point = data[i][1]
        if (!point) {
          continue
        }
        point = point.replace(',', '')
        if (!isNumber(point)) {
          continue
        }
        let ghichu = data[i][2]
        if (ghichu && ghichu.length > 250) {
          this.props.khachhangSetError(`Ghi chú khách hàng ${data[i][0]} quá dài`)
          return
        }
        arrData.push({
          Code: data[i][0],
          Diem: point,
          GhiChu: data[i][2]
        })
      }

      if (arrData.length === 0) {
        this.props.khachhangSetError('Dữ liệu không hợp lệ, hãy điền dữ liệu cho file excel')
        return
      }
      var requestData = {
        store_id: this.state.stores_id,
        loai: khachhangConstant.LoaiKhachHang.Default,
        items: arrData
      }
      const onSuccess = ({ data, message, code }) => {
        if (code && code != 200) {
          this.props.khachhangSetError(message)
          return
        }
        if (data && data.length > 0) {
          this.setState({ dataErr: data })
          this.props.khachhangSetError('Một số khách hàng không cập nhật được, hãy kiểm tra lại')
        } else {
          this.props.khachhangSetMessage(message)
        }
      }
      const onError = ({ message }) => {
        this.props.khachhangSetError(message)
      }
      return this.props.khachhangUpdateListDiemTLRequest(requestData, onSuccess, onError);
    }
  }
  resetErrorAndMsg = () => {
    this.props.khachhangSetError('')
    this.props.khachhangSetMessage('')
    this.setState({ dataErr: [] })
  }
  UploadExcel = (data) => {
    this.resetErrorAndMsg()
    let arrData = [];
    if (data.length > 1) {
      for (var i = 1; i < data.length; i++) {
        let ngaySinh = '';
        if (data[i][8] != '') {
          let tmpNgay = data[i][8].split('/');
          if (tmpNgay.length == 3) {
            ngaySinh = tmpNgay[2] + '-' + tmpNgay[1] + '-' + tmpNgay[0];
          }
        }
        arrData.push({
          MaKhachHang: data[i][0],
          TenKhachHang: data[i][1],
          DiaChi: data[i][2],
          DienThoai: data[i][3],
          MaSoThue: data[i][4],
          HopDongThamGia: data[i][5],
          NguoiDaiDien: data[i][6],
          DiDong: data[i][7],
          NgaySinh: ngaySinh,
          TinhThanh: data[i][9],
          MaQuanLy: data[i][10],
          TrangThai: data[i][11],
          Rank: data[i][12],
          LoaiKhachHangId: data[i][13]
        })
      }
      const { khachhangUploadRequest } = this.props
      var requestData = {
        storeId: this.state.stores_id,
        items: arrData
      };
      return khachhangUploadRequest(requestData);
    }
  }
  removeKhachHangItem = () => {
    var requestData = {
      StoreId: this.state.stores_id,
      khachHangIds: this.state.khachHangIds,
    }
    return this.props.khachhangRemoveRequest(requestData);
  }
  processRemoveClick = () => {
    if (this.state.khachHangIds.length <= 0) {
      return;
    }
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn chắc chắn muốn xóa {this.state.khachHangIds.length > 1 ? "hết các " : ""}khách hàng này không?
            </p>
            <button className="text-danger" onClick={() => {
              this.removeKhachHangItem()
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  processRemoveItem = (item) => {
    this.setState({
      khachHangIds: [item.KhachHangId] || [],
      selectedAll: false
    }, () => {
      $('.cb-item').prop('checked', false);
      $('.cb-item-all').prop('checked', false);
      $('.' + item.KhachHangId).prop('checked', true);
      this.processRemoveClick();
    })
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.khachhang.type == khachhangConstant.KHACHHANG_LIST_SUCCESS) {
      let { list, item } = nextProps.khachhang;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        list: list
      });
    } else if (nextProps.khachhang.type == khachhangConstant.KHACHHANG_DVHC_LIST_SUCCESS) {
      let { listDvhc } = nextProps.khachhang;
      this.setState({
        listDvhc: this.BuildSelectOption(listDvhc)
      });
    } else if (nextProps.khachhang.type == khachhangConstant.KHACHHANG_REMOVE_SUCCESS) {
      this.fetchList()
    } else if (nextProps.khachhang.type == khachhangConstant.KHACHHANG_UPLOAD_SUCCESS) {
      let { dataErr } = nextProps.khachhang;
      if (dataErr && dataErr.length > 0) {
        this.setState({ dataErr });
      } else {
        setTimeout(() => {
          this.setState({ modal: false }, () => {
            this.refresh();
          });
        }, 1000)
      }
    }
  }
  BuildSelectOption(list) {
    var options = [];
    options.push({ value: 0, label: '--- Tất cả ---', ma: "0" })
    if (list && list.length > 0) {
      list.map((item) => { options.push({ value: item.TinhThanhId, label: item.Ten, ma: item.Ma }) });
    }
    return options;
  }
  viewTraThuong = (obj) => {
    obj["SoDiemTraThuong"] = (obj.DiemTichLuy)
    obj["SoTienTraThuong"] = 0
    obj["NgayTraThuong"] = common.currentDate()
    obj["Loai"] = khachhangConstant.LoaiKhachHang.Default
    this.setState({ modalUpdateTraThuong: true, objTraThuong: obj })
  };
  handleCloseTraThuong = () => {
    this.setState({ modalUpdateTraThuong: false })
  }
  onChangeSortItem = (sortValue) => {
    this.setState({ sortValue })
  }
  TraThuongKhachHang = (obj) => {
    var requestData = {
      khachHangId: obj.KhachHangId,
      loai: obj.Loai,
      soTien: obj.SoTienTraThuong,
      diem: obj.SoDiemTraThuong,
      ghiChu: obj.GhiChu,
      ngayTraThuong: obj.NgayTraThuong.unix()
    };
    this.props.khachhangTraThuongRequest(requestData, () => {
      this.handleCloseTraThuong();
      this.search();
    })
  }
  render() {
    const {
      handleSubmit,
      khachhang: {
        listRequesting,
        isRequesting,
        isPopupLoading,
        errors,
        messages,
        listNhomKH
      },
    } = this.props
    const { list,
      dataErr,
      listDvhc,
      selectedOptionTinhThanh,
      khachHangIds,
      sortItems,
      sortValue,
      phanLoaiKh,
      phanLoaiValue
    } = this.state
    const khachHangStatusEnum = common.GetKhachHangStatusValue().map(item => {
      const text = common.getKhachHangStatusText(item)
      return { value: item, text: text.result, className: text.className }
    })
    const hasRemoveRight = HasPermission(BtnPermissions.KhachHang.REMOVE)
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row>
                <Col sm="4" md="3" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md" className="display-table">
                    <InputGroupAddon className="display-table-cell" addonType="prepend" autoComplete="off">Tỉnh/TP</InputGroupAddon>
                    <div className="border display-table-cell form-control p-0 m-0 w-100">
                      <Select
                        styles={customSelectStyles}
                        name="TinhThanh"
                        placeholder="---"
                        value={selectedOptionTinhThanh}
                        onChange={this.handleSelectChange}
                        options={listDvhc}
                      />
                    </div>
                  </InputGroup>
                </Col>
                <Col sm="4" md="4" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md" className="display-table">
                    <InputGroupAddon className="display-table-cell" addonType="prepend" autoComplete="off" >Quản lý</InputGroupAddon>
                    <Input name="tenQuanLy"
                      className="display-table-cell w-100"
                      placeholder="Tên/mã quản lý"
                      value={this.state.TenQuanLy}
                      onChange={this.handleSearchChange.bind(this, "tenQuanLy")}
                      onKeyDown={e => this.keyPress(e)} />
                  </InputGroup>
                </Col>
                <Col sm="4" md="5" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md" className="display-table">
                    <InputGroupAddon className="display-table-cell" addonType="prepend" autoComplete="off" >Khách hàng</InputGroupAddon>
                    <Input name="keyword"
                      className="display-table-cell w-100"
                      placeholder="Mã, Tên, email, điện thoại, ghi chú"
                      value={this.state.keyword}
                      onChange={this.handleSearchChange.bind(this, "keyword")}
                      maxLength="100"
                      onKeyDown={e => this.keyPress(e)} />
                  </InputGroup>
                </Col>
                <Col sm="4" md="4" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md" className="display-table">
                    <InputGroupAddon className="display-table-cell" addonType="prepend" autoComplete="off" >Trạng thái</InputGroupAddon>
                    <select name="TrangThai" className="form-control display-table-cell w-100" value={this.state.TrangThaiId} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                      <option value={-1}>---Trạng thái---</option>
                      {(khachHangStatusEnum.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.text}
                        </option>
                      )))}
                    </select>
                  </InputGroup>
                </Col>
                <Col sm="4" md="4" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md" className="display-table">
                    <InputGroupAddon className="display-table-cell" addonType="prepend" autoComplete="off" >Nhóm khách hàng</InputGroupAddon>
                    <select name="TrangThai" className="form-control display-table-cell w-100" value={this.state.NhomKhachHangId}
                      onChange={this.handleSelectChange.bind(this, "NhomKhachHang")}>
                      <option value={0}>---Tất cả---</option>
                      {(listNhomKH && listNhomKH.length &&
                        listNhomKH.map((item, index) => (
                          <option key={index} value={item.Id}>{item.Ten}</option>
                        )))}
                    </select>
                  </InputGroup>
                </Col>
                <Col sm="4" md="4" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md" className="display-table">
                    <InputGroupAddon className="display-table-cell" addonType="prepend" autoComplete="off" >Phân loại</InputGroupAddon>
                    <select name="TrangThai" className="form-control display-table-cell w-100" value={phanLoaiValue}
                      onChange={this.handleSelectChange.bind(this, "PhanLoaiKhachHang")}>
                      {(phanLoaiKh && phanLoaiKh.length &&
                        phanLoaiKh.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.text}
                          </option>
                        )))}
                    </select>
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="pull-left mr-1" onClick={handleSubmit(this.search)}>
                <i className="fa fa-search"></i> Tìm kiếm</Button>
              <ButtonExt btnClass="mr-1"
                color="success"
                btnSize="80"
                iconClass="fa-file-excel-o"
                displayText="Xuất excel"
                btnClick={() => this.exportXls({})}
                permission={BtnPermissions.KhachHang.EXPORT_EXCEL} />
              <ButtonExt btnClass="mr-1"
                color="success"
                btnSize="80"
                iconClass="fa-users"
                displayText="Phân q/lý"
                btnClick={() => this.EditkhachhangUser({})}
                permission={BtnPermissions.KhachHang.ADD_USERS} />
              <ButtonExt btnClass="mr-1"
                color="primary"
                iconClass="fa-upload"
                displayText="Nhập từ file"
                btnClick={() => this.toggle()}
                permission={BtnPermissions.KhachHang.UPLOAD_EXCEL} />
              <ButtonExt btnClass="mr-1"
                color="primary"
                iconClass="fa-upload"
                displayText="Nhập điểm"
                btnClick={() => this.pointToggle()}
                permission={BtnPermissions.KhachHang.UPLOAD_DIEM_EXCEL} />
              <ButtonExt btnClass="mr-1"
                color="primary"
                iconClass="fa-plus"
                displayText="Thêm mới"
                btnClick={() => this.EditkhachhangItem({})}
                permission={BtnPermissions.KhachHang.ADD_OR_UPDATE} />
              <ButtonExt btnClass="mr-1"
                color="danger"
                iconClass="fa fa-trash-o"
                displayText="Xóa chọn"
                isDisabled={khachHangIds.length === 0}
                btnClick={() => this.processRemoveClick({})}
                permission={BtnPermissions.KhachHang.REMOVE} />
            </div>
            <div className="w-100">
              <SortRecordText
                items={sortItems}
                labelText="Sắp xếp"
                valueText={sortValue}
                onChangeItem={this.onChangeSortItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="30px" className="text-center">
                      {hasRemoveRight && (
                        <CheckboxExt
                          onClick={() => this.checkedKhachHangAll()}
                          checkId="all"
                          chkClass="cb-item-all"
                          permission={BtnPermissions.KhachHang.ADD_OR_UPDATE} />
                      )}
                    </th>
                    <th scope="col" className="text-left" colSpan="8">Tên khách hàng</th>
                  </tr>
                  <tr>
                    <th scope="col" className="text-center"></th>
                    <th scope="col" className="text-left">Địa chỉ</th>
                    <th scope="col" className="text-center">Thành phố</th>
                    <th scope="col" className="text-center">Điện thoại</th>
                    <th scope="col" className="text-center">Điểm</th>
                    <th scope="col" className="text-center">Quản lý</th>
                    <th scope="col" className="text-center">Trạng thái</th>
                    <th scope="col" className="text-center">Nhóm KH</th>
                    <th scope="col" className="text-left">Ghi chú</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => {
                      const status = common.getKhachHangStatusText(res.TrangThai)
                      return (
                        <Fragment key={idx + 1}>
                          <tr>
                            <td scope="row" className="text-center">
                              <CheckboxExt
                                chkClass={'cb-item ' + res.KhachHangId}
                                onClick={() => this.handleKhachHangClick(res)}
                                checkId={idx + 1}
                                permission={BtnPermissions.KhachHang.REMOVE} />
                            </td>
                            <td className="text-left" colSpan="8">
                              <div>
                                <div className="btn-group ml-2" role="group">
                                  <ButtonExt btnClass="pull-right mr-1"
                                    size="xs"
                                    color="danger"
                                    iconClass="fa-trash fa-lg"
                                    displayText="Xóa"
                                    btnClick={() => this.processRemoveItem(res)}
                                    permission={BtnPermissions.KhachHang.REMOVE} />
                                  <ButtonExt btnClass="pull-right mr-1"
                                    size="xs"
                                    color="primary"
                                    iconClass="fa-edit fa-lg"
                                    displayText="Sửa"
                                    btnClick={() => this.EditkhachhangItem(res)}
                                    permission={BtnPermissions.KhachHang.ADD_OR_UPDATE} />
                                  <ButtonExt btnClass="pull-right mr-1"
                                    size="xs"
                                    color="warning"
                                    iconClass="fa-list fa-lg"
                                    displayText="Hợp đồng"
                                    btnClick={() => this.EditHopDongItem(res)}
                                    permission={BtnPermissions.KhachHang.ADD_OR_UPDATE} />
                                </div>
                                <a href='#' target="_blank" onClick={(e) => this.viewkhachhangItem(e, res)}>
                                  {res.Ten}&nbsp;/&nbsp;{res.Ma}
                                </a>
                                {res.IsIntergrate && res.IsIntergrate == 1 && (
                                  <i className={"fa fa-check-circle text-success ml-1"} title={"Liên thông thuốc 247"}></i>
                                )}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="text-center">{idx + 1}</td>
                            <td className="text-left">{res.DiaChi}</td>
                            <td className="text-center">{res.RegionName}</td>
                            <td className="text-center">{res.DienThoai}</td>
                            <td className="text-center">
                              <div>{parseFloat(res.DiemTichLuy || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</div>
                              {
                                (res.DiemTichLuy || 0) > 0 ?
                                  <ButtonExt btnClass="pull-right mr-1"
                                    size="xs"
                                    color="primary"
                                    iconClass="fa-money"
                                    displayText="Trả thưởng"
                                    btnClick={() => this.viewTraThuong(res)}
                                    permission={BtnPermissions.TraThuongDiem.TRATHUONG} />
                                  : ""
                              }
                            </td>
                            <td className="text-center">{res.TenQuanLy} ({res.MaQuanLy})</td>
                            <td className={"text-center " + status.className}>
                              <span className="d-none d-lg-block">{status.result}</span>
                            </td>
                            <td className="text-center">{res.TenLoaiKhachHang}</td>
                            <td className="text-left">{res.GhiChu}</td>
                          </tr>
                        </Fragment>
                      )
                    })
                  )}
                </tbody>
                <tfoot className="d-lg-none d-xl-none">
                  <tr>
                    <td colSpan={HasPermission ? 12 : 11}>
                      {(khachHangStatusEnum.map((item, index) => (
                        <span key={index} className={`mr-2`}>
                          <i style={{ width: 20, height: 15, display: 'inline-block' }} className={`mr-1 ${item.className}`}></i>{item.text}</span>
                      )))}
                    </td>
                  </tr>
                </tfoot>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
          <div>
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
              <BlockUi tag="div" blocking={isPopupLoading} >
                <ModalHeader toggle={this.toggle}>Thêm khách hàng từ danh sách</ModalHeader>
                <ModalBody>
                  <ExcelReader UploadExcel={this.UploadExcel} />
                  <div style={{ maxHeight: 300, overflowX: "auto" }}>
                    {dataErr && !!dataErr.length && (
                      dataErr.map((res, idx) => (
                        <p key={idx} className="text-danger mb-0"><i className="fa fa-exclamation-circle"></i> {res}</p>
                      ))
                    )}
                  </div>
                  {!isPopupLoading && !!errors.length && (
                    <Errors errors={errors} />
                  )}
                  {dataErr && dataErr.length == 0 && !isPopupLoading && !!messages.length && (
                    <Messages messages={messages} />
                  )}
                </ModalBody>
                <ModalFooter style={{ padding: "5px" }}>
                  <Button size="md" color="success" onClick={() => this.DownLoadFile(khachhangConstant.KHACHHANG_FILE_TEMPLATE)}><i className="fa fa-download"></i> Tải file mẫu</Button>{' '}
                  <Button size="md" color="secondary" onClick={this.toggle}><i className="fa fa-close"></i> Đóng</Button>
                </ModalFooter>
              </BlockUi>
            </Modal>
            <Modal isOpen={this.state.modalPoint} toggle={this.pointToggle} className={this.props.className}>
              <ModalHeader toggle={this.pointToggle}>Nhập điểm từ excel</ModalHeader>
              <ModalBody>
                <ExcelReader UploadExcel={this.UploadPointExcel} btnText="Cập nhật" />
                <div style={{ maxHeight: 200, overflowX: "auto" }}>
                  {dataErr && !!dataErr.length && (
                    dataErr.map((res, idx) => (
                      <p key={idx} className="text-danger mb-0"><i className="fa fa-exclamation-circle"></i> {res}</p>
                    ))
                  )}
                </div>
                {!isRequesting && !!errors.length && (
                  <Errors errors={errors} />
                )}
                {dataErr && dataErr.length == 0 && !isRequesting && !!messages.length && (
                  <Messages messages={messages} />
                )}
              </ModalBody>
              <ModalFooter style={{ padding: "5px" }}>
                <Button size="md" color="success" onClick={() => this.DownLoadFile(khachhangConstant.KHACHHANG_FILE_DIEM_TICHLUY_TEMPLATE)}><i className="fa fa-download"></i> Tải file mẫu</Button>{' '}
                <Button size="md" color="secondary" onClick={this.pointToggle}><i className="fa fa-close"></i> Đóng</Button>
              </ModalFooter>
            </Modal>
          </div>
          <ViewTraThuong item={this.state.objTraThuong}
            isRequesting={isRequesting}
            isOpen={this.state.modalUpdateTraThuong}
            onClose={this.handleCloseTraThuong}
            TraThuongKhachHang={this.TraThuongKhachHang}
            errors={errors}
            messages={messages}
          />
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  khachhang: state.khachhang,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  khachhangListRequest: khachhangAction.khachhangListRequest,
  khachhangUpdateRequest: khachhangAction.khachhangUpdateRequest,
  khachhangExportXlsRequest: khachhangAction.khachhangExportXlsRequest,
  khachhangUploadRequest: khachhangAction.khachhangUploadRequest,
  khachhangDvhcListRequest: khachhangAction.khachhangDvhcListRequest,
  khachhangRemoveRequest: khachhangAction.khachhangRemoveRequest,
  khachhangUpdateListDiemTLRequest: khachhangAction.khachhangUpdateListDiemTLRequest,
  khachhangSetMessage: khachhangAction.khachhangSetMessage,
  khachhangSetError: khachhangAction.khachhangSetError,
  khachhangNhomListRequest: khachhangAction.khachhangNhomListRequest,
  khachhangTraThuongRequest: khachhangAction.khachhangTraThuongRequest
})(KhachHang)
const formed = reduxForm({
  form: 'khachhang',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/KhachHang/Khachhang.js